import React, { Fragment } from 'react';
import { TextArea, Icon } from '@gerdau/hefesto';

import { BoldText, WarningText } from '../styles';
import { Container, WarningMessage } from './styles';
import { ISelectedTableOrders, UpdateErrorMsgMap, UpdateErrorType } from '..';

interface ICancelUpdate {
  disableTextArea: boolean;
  message: string;
  setMessage: (newMessage: string, option: string) => void;
  showErrorMessage: string;
  warningComponents: JSX.Element[] | null;
  hasUpdateError: boolean;
  selectedItens: ISelectedTableOrders[];
}

const CancelUpdate: React.FC<ICancelUpdate> = ({
  disableTextArea,
  message,
  setMessage,
  showErrorMessage,
  warningComponents,
  hasUpdateError,
  selectedItens
}) => {
  return (
    <>
      <p>
        <BoldText>Cancelamento</BoldText>
      </p>
      <p>
        Ao solicitar o cancelamento, o processo será analisado pela central de
        atendimento, que entrará em contato através do email cadastrado.
      </p>
      <p>
        <BoldText>Fique atento ao email de acesso e a caixa de spam</BoldText>
      </p>
      {warningComponents?.length
        ? warningComponents.map((component, index) => (
            <Fragment key={index}>{component}</Fragment>
          ))
        : null}
      {hasUpdateError && (
        <>
          {selectedItens.map((item) => {
            if (
              item.materials.some(
                (m) => m.errorType && m.errorType === UpdateErrorType.STATUS
              )
            ) {
              return (
                <Fragment key={item.orderNumber}>
                  <WarningText>
                    Para o pedido <strong>{item.orderNumber}</strong> {': '}
                    {item.materials.map((material) => {
                      if (material.errorType) {
                        return (
                          <div
                            key={material.id}
                            style={{ marginBottom: '1rem' }}
                          >
                            <span>
                              O item <strong>{material.description}</strong> não
                              pôde ser alterado porque{' '}
                              <strong>
                                {UpdateErrorMsgMap.get(material.errorType)}
                              </strong>
                            </span>
                            <br />
                          </div>
                        );
                      }
                    })}
                  </WarningText>
                </Fragment>
              );
            }
          })}
          {selectedItens
            .flatMap((items) => items.materials)
            .some(
              (m) => m.errorType && m.errorType === UpdateErrorType.STATUS
            ) && (
            <WarningText>
              <strong>
                Selecione na tabela apenas o item que pode ser alterado.
              </strong>
            </WarningText>
          )}
        </>
      )}
      <Container>
        <TextArea
          label="Motivo do cancelamento"
          placeholder="Explique o motivo do cancelamento"
          name="Text area motivo do cancelamento"
          minLength={1}
          maxLength={250}
          disabled={disableTextArea}
          resizable={false}
          cols={38}
          value={message}
          onChange={(e) => setMessage(e.target.value, 'cancel')}
          rows={8}
        />
        {showErrorMessage.length ? (
          <WarningMessage>
            <Icon option="Alert" variant="danger" />
            {showErrorMessage}
          </WarningMessage>
        ) : null}
      </Container>
    </>
  );
};

export default CancelUpdate;
